import { ICreateTreinamentoUseCase } from "../../../presentation/useCases/create/create_treinamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateTreinamentoUseCase
 */

export class CreateTreinamentoUseCase implements ICreateTreinamentoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async createTreinamento(
    ativo: number,
    nome: string,
    versao: string,
    cargaHoraria: number,
    conteudoProgramatico: string | null,
  ): Promise<void> {
    await this.repository.createTreinamento(
      ativo,
      nome,
      versao,
      cargaHoraria,
      conteudoProgramatico,
    );
  }
}
